export default "__VITE_ASSET__Djx72acr__"